import React, { useEffect, useMemo, useState } from 'react';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Popover from 'react-bootstrap/Popover';
import { FormGroup } from 'react-bootstrap';
import { MultiSelect } from 'react-multi-select-component';
import { useSelector, useDispatch } from 'react-redux';
import { isEmpty, cloneDeep } from 'lodash';
import Select from 'react-select';
import { useTranslation } from 'react-i18next';
import * as sampleTodoListAction from '../Dashboard/TodoList/Samples/store/TodoList.action';
import * as planningActualAction from './store/PlanningActual.action';
import * as action from '../Library/BomLibrary/store/BomLibrary.action';
import { usePlanningActualState } from './Context/index';
import { toasterMsg } from '../../Components/Toaster/Toaster';
import { createOptions, getYears, customStyles, checkArray } from '../../Components/helper';
import useCalculationHooks from './Hooks/useCalculationHooks';
import { getPCTypesDetails, getCatBasedOnPT } from '../SystemMasters/Store/SystemMasters.action';
import { CurrentYearOption } from '../../Components/Utility/CurrentYearDropdown';

function FiltePlanningActual({ filterData, planningState, setPlanningState }) {
  const dispatch = useDispatch();
  const { t } = useTranslation('common');
  const reducers = useSelector((redState) => redState);
  const {
    UserDetails: {
      userInfo: { userId },
    },
    SystemMastersDetails: { pcTypeList },
  } = reducers;
  const pcTypeOptions = createOptions(pcTypeList || [], 'name', '_id');
  const [selectedYear1, setSelectedYear1] = useState();
  const [selectedSeason1, setSelectedSeason1] = useState();
  const [catBasedOnPTData, setCatBasedOnPTData] = useState(false);
  const localStorageFilter = JSON.parse(localStorage.getItem('planningFilter'));
  const [state, setState] = useState({
    yearPrevOptions: [],
    yearOptions: createOptions(getYears(), 'name', '_id'),
    categoryOptions: [],
    categoryRawOptions: [],
    selectedYear: '',
    selectedCategory: [],
    selectedProductType: [],
    seasonsOptions: [],
    selectedSeason: '',
    attributesOptions: [],
    selectedAttributesOptions: [],
    selectedCompareYears: [],
    filterApplied: false,
    isLoading: false,
  });
  const {
    selectedYear,
    selectedCategory,
    selectedProductType,
    yearPrevOptions,
    yearOptions,
    categoryOptions,
    categoryRawOptions,
    seasonsOptions,
    selectedSeason,
    attributesOptions,
    selectedAttributesOptions,
    selectedCompareYears,
    filterApplied,
    isLoading,
  } = state;

  const { planningActual, setPlanningActual } = usePlanningActualState();
  const { staticFields } = planningActual;
  const attributes = createOptions(staticFields, 'name', '_id');
  const { calculateColumnsValues } = useCalculationHooks();

  const currentBackYears = (startYear) => {
    if (!startYear) {
      return [];
    }
    return Array.from({ length: 20 }, (_, i) => startYear - i - 1).map((year) => ({ name: year.toString(), _id: year }));
  };

  const handleSelectChange = async (value, text, name) => {
    if (name === 'compareYears') {
      const sameYear = value.find((o) => o === selectedYear);
      if (!sameYear) {
        setState((prevState) => ({
          ...prevState,
          selectedCompareYears: value,
        }));
      }
    }

    if (name === 'year') {
      const yearArray = selectedCompareYears || [];
      const sameYearIndex = yearArray.findIndex((year) => year === value);
      yearArray.splice(sameYearIndex, 1);

      const years = currentBackYears(value);
      setState((prevState) => ({
        ...prevState,
        selectedYear: value,
        selectedCompareYears: yearArray,
        yearPrevOptions: createOptions(years, 'name', '_id'),
      }));
    }

    if (name === 'attributes') {
      setState((prevState) => ({
        ...prevState,
        selectedAttributesOptions: value,
      }));
      if (value.length === 0) {
        setPlanningActual((prevState) => ({
          ...prevState,
          hideAllFields: true,
        }));
      }
    }
    if (name === 'season') {
      setState((prevState) => ({
        ...prevState,
        selectedSeason: value,
      }));
    }
    if (name === 'category') {
      setState((prevState) => ({
        ...prevState,
        selectedCategory: value,
      }));
    }
    if (name === 'productType') {
      setState((prevState) => ({
        ...prevState,
        selectedProductType: value,
        // reset Category 1 when PT changes under cascading flag
        selectedCategory: catBasedOnPTData ? [] : prevState.selectedCategory,
      }));
    }
  };

  const clearAll = async () => {
    localStorage.removeItem('planningFilter');
    setState((prevState) => ({
      ...prevState,
      selectedYear: '',
      selectedCategory: [],
      selectedProductType: [],
      selectedSeason: '',
      selectedAttributesOptions: attributes.map((o) => o._id),
      selectedCompareYears: [],
    }));
    setSelectedYear1(null);
    setSelectedSeason1(null);
    setPlanningActual((prevState) => ({
      ...prevState,
      modifiedData: null,
      planningActual: null,
    }));

    setPlanningState({ ...planningState, categoryYear: null });
    dispatch(planningActualAction.resetData());
  };
  const checkRequiredField = () => {
    const requirePT = catBasedOnPTData ? checkArray(selectedProductType) : true;
    if (selectedYear && selectedSeason && checkArray(selectedCategory) && requirePT) {
      return true;
    }
    {
      catBasedOnPTData
        ? toasterMsg(t('PLANNING_ACTUAL.FILTER_PLANING_ACTUAL.YEAR_SEASON_CATEGORY_PRODUCTTYPE_REQUIRED'), 'danger')
        : toasterMsg(t('PLANNING_ACTUAL.FILTER_PLANING_ACTUAL.YEAR_SEASON_CATEGORY_REQUIRED'), 'danger');
    }
    return false;
  };
  const applyFilter = async () => {
    if (checkRequiredField()) {
      setState((prevState) => ({
        ...prevState,
        filterApplied: true,
        isLoading: true,
      }));

      const paramsObj = {
        year: selectedYear,
        season: selectedSeason,
        seasonText: selectedSeason1,
        categoryOne: selectedCategory,
        ...(catBasedOnPTData && { productType: selectedProductType }),
        loading: true,
      };
      const localStorageObj = {
        ...paramsObj,
        selectedCompareYears,
        selectedAttributesOptions,
      };

      localStorage.setItem('planningFilter', JSON.stringify(localStorageObj));
      filterData(paramsObj);
      if (checkArray(selectedCompareYears)) {
        paramsObj.selectedCompareYears = selectedCompareYears;
        await dispatch(planningActualAction.fetchSelectableYear(paramsObj));
      } else {
        const response = await dispatch(planningActualAction.fetchCategoryData(paramsObj));
        if (response) {
          const data = cloneDeep(response);
          if (data?.overallTotals) {
            await calculateColumnsValues(data, data?.overallTotals);
          } else {
            const copiedOverAllTotal = cloneDeep({
              plannedSales: '0',
              actualSales: '0',
              plannedMix: '0',
              actualMix: '0',
              plannedSalesUnit: '0',
              actualSalesUnit: '0',
              plannedASP: '0',
              actualASP: '0',
              plannedOption: '0',
              actualOption: '0',
              plannedSPO: '0',
              actualCOS: '0',
              actualSPO: '0',
              plannedCOS: '0',
              plannedBuyingMargin: '0',
              actualBuyingMargin: '0',
              plannedMarginRate: '0',
              actualMarginRate: '0',
              plannedCashMargin: '0',
              actualCashMargin: '0',
              plannedMarkdown: '0',
              actualMarkdown: '0',
              plannedMarkdownPer: '0',
              actualMarkdownPer: '0',
              isPlannedSales: true,
              isActualSales: true,
            });
            copiedOverAllTotal.isPlannedSales = true;
            copiedOverAllTotal.isActualSales = true;
            await calculateColumnsValues(data, copiedOverAllTotal);
          }
        }
      }
      setState((prevState) => ({
        ...prevState,
        isLoading: false,
      }));
    }
  };

  const setSeasonsData = async () => {
    const seasonsRes = await dispatch(action.fetchSeason({ isActive: 1, loggedInUserId: userId }));

    const seasonsOpt = await createOptions(seasonsRes.payload, 'name', '_id');

    setState((prevState) => ({
      ...prevState,
      seasonsOptions: seasonsOpt,
      selectedAttributesOptions: attributes.map((o) => o._id),
    }));
  };

  useEffect(() => {
    const fetchCatBasedOnPTData = async () => {
      try {
        const res = await dispatch(getCatBasedOnPT());
        setCatBasedOnPTData(!!res);
      } catch (e) {
        setCatBasedOnPTData(false);
      }
    };
    fetchCatBasedOnPTData();
  }, [dispatch]);

  useEffect(() => {
    try {
      dispatch(
        getPCTypesDetails({
          loggedInUserId: userId,
          isActive: true,
          tier: 'Tier1',
        }),
      );
    } catch (e) {
      // no-op
    }
  }, [dispatch, userId]);

  useEffect(() => {
    const callFn = async () => {
      const category = [1];
      for (const cat of category) {
        const categorys = await dispatch(
          sampleTodoListAction.fetchCategoryAction({
            categoryType: cat,
            loggedInUserId: userId,
          }),
        );
        setState((prevState) => ({
          ...prevState,
          categoryOptions: cloneDeep(createOptions(categorys, 'name', '_id')),
          categoryRawOptions: cloneDeep(categorys || []),
        }));
      }
    };
    if (!isEmpty(userId)) {
      callFn();
      setSeasonsData();
    }
  }, [dispatch, userId]);

  useEffect(() => {
    if (selectedAttributesOptions.length > 0) {
      const kl = staticFields.map((o) => {
        if (!selectedAttributesOptions.includes(o._id)) {
          o.display = false;
        } else {
          o.display = true;
        }
        return o;
      });
      setPlanningActual({ ...planningActual, staticFields: kl, hideAllFields: false });
    } else {
      const allFalse = staticFields.map((eleStatic) => {
        eleStatic.display = false;
        return eleStatic;
      });
      setPlanningActual({ ...planningActual, staticFields: allFalse });
    }
  }, [selectedAttributesOptions]);

  useEffect(() => {
    const init = async () => {
      if (!filterApplied && !isLoading) {
        setState((prevState) => ({
          ...prevState,
          isLoading: true,
        }));
        filterData(localStorageFilter);
        delete localStorageFilter?.selectedAttributesOptions;
        if (checkArray(localStorageFilter?.selectedCompareYears)) {
          dispatch(planningActualAction.fetchSelectableYear(localStorageFilter));
        } else {
          const response = await dispatch(planningActualAction.fetchCategoryData(localStorageFilter));
          if (response) {
            const data = cloneDeep(response);
            await calculateColumnsValues(data, response?.overallTotals);
          }
        }

        setFilterOptions(localStorageFilter);

        const years = currentBackYears(localStorageFilter?.year);
        setState((prevState) => ({
          ...prevState,
          filterApplied: true,
          isLoading: false,
          attributesOptions: attributes,
          yearPrevOptions: createOptions(years, 'name', '_id'),
        }));
      }
    };

    init();
  }, [localStorageFilter, dispatch, seasonsOptions]);

  const setFilterOptions = (filteredData) => {
    const getYearObj = yearOptions.find((yearEle) => yearEle._id === filteredData?.year);
    getYearObj &&
      setState((prevState) => ({
        ...prevState,
        selectedYear: getYearObj._id,
      }));

    setState((prevState) => ({
      ...prevState,
      selectedSeason: filteredData?.season,
    }));

    setSelectedYear1(getYearObj);
    setSelectedSeason1(filteredData?.seasonText ? filteredData.seasonText : null);

    setState((prevState) => ({
      ...prevState,
      selectedCategory: filteredData?.categoryOne,
      selectedProductType: filteredData?.productType || [],
      selectedCompareYears: filteredData?.selectedCompareYears || [],
    }));
  };

  // Derived filtered Category 1 options when PT flag is ON
  const categoryOneFilteredOptions = useMemo(() => {
    if (!catBasedOnPTData) return categoryOptions;
    const pts = selectedProductType || [];
    if (!Array.isArray(pts) || pts.length === 0) return categoryOptions; // show all until PT selected
    // Filter raw categories that have productType or isUsedProductType intersecting selectedProductType
    const filteredRaw = (categoryRawOptions || []).filter((item) => {
      const ptArr = item?.productType || [];
      const usedPtArr = item?.isUsedProductType || [];
      return ptArr?.some?.((id) => pts.includes(id)) || usedPtArr?.some?.((id) => pts.includes(id));
    });
    // If enrichment is not present, fallback to original options
    if (!filteredRaw?.length) return categoryOptions;
    return createOptions(filteredRaw, 'name', '_id');
  }, [catBasedOnPTData, selectedProductType, categoryOptions, categoryRawOptions]);

  return (
    <>
      <div className="custom-react-select w-200px">
        <MultiSelect
          name="attributes"
          options={attributesOptions}
          className="custom-multiselect border-bottom-none"
          value={attributesOptions.filter((val) => !isEmpty(selectedAttributesOptions) && selectedAttributesOptions.includes(val._id))}
          labelledBy={t('PLANNING_ACTUAL.FILTER_PLANING_ACTUAL.SELECT_LABEL_ATTRIBUTES')}
          onChange={(selected) => {
            handleSelectChange(
              selected.map((val) => val._id),
              selected.map((val) => val.name),
              'attributes',
            );
          }}
        />
      </div>
      <button
        className="filter-btn filter-button_delete"
        type="button"
        title={t('PLANNING_ACTUAL.FILTER_PLANING_ACTUAL.MODAL_TITLE')}
        aria-label={t('PLANNING_ACTUAL.FILTER_PLANING_ACTUAL.MODAL_TITLE')}
      >
        <OverlayTrigger
          placement="bottom"
          trigger="click"
          rootClose
          overlay={
            <Popover className="custom-popover select-min-height horizontal-view">
              <Popover.Content>
                <div className="product-costing-filter">
                  <div className="filter-text">
                    <FormGroup className="mb-2">
                      <p className="select-label asterisk-req mb-0">
                        {t('PLANNING_ACTUAL.FILTER_PLANING_ACTUAL.SELECT_LABEL_YEAR')}
                        <span>*</span>
                      </p>
                      <div className="custom-react-select ">
                        <Select
                          components={{ Option: CurrentYearOption }}
                          name="year"
                          styles={customStyles}
                          isClearable
                          options={yearOptions || []}
                          getOptionLabel={(option) => `${option.label}`}
                          getOptionValue={(option) => `${option.value}`}
                          value={selectedYear1 || null}
                          onChange={(val) => {
                            setSelectedYear1(val);
                            handleSelectChange(val ? val._id : null, val ? val.name : null, 'year');
                          }}
                          placeholder={t('PLANNING_ACTUAL.FILTER_PLANING_ACTUAL.SELECT_YEAR')}
                        />
                      </div>
                    </FormGroup>
                    <FormGroup className="mb-2">
                      <p className="select-label asterisk-req mb-0">
                        {t('PLANNING_ACTUAL.FILTER_PLANING_ACTUAL.SELECT_LABEL_SEASON')}
                        <span>*</span>
                      </p>
                      <div className="custom-react-select ">
                        <Select
                          name="season"
                          styles={customStyles}
                          isClearable
                          options={seasonsOptions || []}
                          getOptionLabel={(option) => `${option.label}`}
                          getOptionValue={(option) => `${option.value}`}
                          value={selectedSeason1 || null}
                          onChange={(val) => {
                            setSelectedSeason1(val);
                            handleSelectChange(val ? val._id : null, val ? val.name : null, 'season');
                          }}
                          placeholder={t('PLANNING_ACTUAL.FILTER_PLANING_ACTUAL.SELECT_SEASON')}
                        />
                      </div>
                    </FormGroup>
                    {catBasedOnPTData && (
                      <FormGroup className="mb-2">
                        <p className="select-label  asterisk-req mb-0">
                          Product Type
                          <span>*</span>
                        </p>
                        <div className="custom-react-select ">
                          <MultiSelect
                            name="productType"
                            options={pcTypeOptions}
                            className="custom-multiselect"
                            value={pcTypeOptions.filter((val) => !isEmpty(selectedProductType) && selectedProductType.includes(val.value))}
                            labelledBy="Product Type"
                            onChange={(selected) => {
                              handleSelectChange(
                                selected.map((val) => val.value),
                                selected.map((val) => val.label),
                                'productType',
                              );
                            }}
                          />
                        </div>
                      </FormGroup>
                    )}
                    <FormGroup className="mb-2">
                      <p className="select-label  asterisk-req mb-0">
                        {t('PLANNING_ACTUAL.FILTER_PLANING_ACTUAL.CATEGORY1')}
                        <span>*</span>
                      </p>
                      <div className="custom-react-select ">
                        <MultiSelect
                          name="category1"
                          options={
                            catBasedOnPTData && Array.isArray(selectedProductType) && selectedProductType.length ? categoryOneFilteredOptions : categoryOptions
                          }
                          className="custom-multiselect"
                          value={(catBasedOnPTData && Array.isArray(selectedProductType) && selectedProductType.length
                            ? categoryOneFilteredOptions
                            : categoryOptions
                          ).filter((val) => !isEmpty(selectedCategory) && selectedCategory.includes(val._id))}
                          disabled={catBasedOnPTData && !(Array.isArray(selectedProductType) && selectedProductType.length > 0)}
                          labelledBy={t('PLANNING_ACTUAL.FILTER_PLANING_ACTUAL.SELECT_CATEGORY1')}
                          onChange={(selected) => {
                            handleSelectChange(
                              selected.map((val) => val._id),
                              selected.map((val) => val.name),
                              'category',
                            );
                          }}
                        />
                      </div>
                    </FormGroup>
                    <FormGroup className="mb-2">
                      <p className="select-label mb-0">{t('PLANNING_ACTUAL.FILTER_PLANING_ACTUAL.COMPARING_YEARS')}</p>
                      <div className="custom-react-select ">
                        <MultiSelect
                          name="compareYears"
                          options={yearPrevOptions}
                          className="custom-multiselect"
                          value={yearPrevOptions.filter((val) => !isEmpty(selectedCompareYears) && selectedCompareYears.includes(val._id))}
                          labelledBy={t('PLANNING_ACTUAL.FILTER_PLANING_ACTUAL.SELECT_YEAR')}
                          onChange={(selected) => {
                            handleSelectChange(
                              selected.map((val) => val._id),
                              selected.map((val) => val.name),
                              'compareYears',
                            );
                          }}
                        />
                      </div>
                    </FormGroup>
                  </div>

                  <div className="btn-container">
                    <button type="button" disabled={isLoading} className="btn btn-default mr-1" onClick={() => applyFilter()}>
                      {t('PLANNING_ACTUAL.FILTER_PLANING_ACTUAL.APPLY_FILTER')}
                    </button>
                    <button type="button" className="btn btn-default" onClick={() => clearAll()}>
                      {t('PLANNING_ACTUAL.FILTER_PLANING_ACTUAL.CLEAR')}
                    </button>
                  </div>
                </div>
              </Popover.Content>
            </Popover>
          }
        >
          <i className="icon-filter" />
        </OverlayTrigger>
      </button>
    </>
  );
}

export default FiltePlanningActual;
